import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Nav,
} from 'grommet';

import { Trans } from "react-i18next";
import { animated, useSpring, useTrail } from "react-spring";
import useWindowSize from '../utils/WindowSize';
import { scrollToID } from '../utils/Misc';
import Settings from '../constants/Settings';
import LanguageSelector from './utility/LanguageSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTwitter, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';

import logo from '../assets/images/logo.png';
import hof_logo from '../assets/images/HOF-LOGO-transparent-white.png';
import hof_logo_2x from '../assets/images/HOF-LOGO-transparent-white@2x.png';

const MyNav = ({ i18n, match, location, showSideBar, showNav, setShowNav, currentYear }) => {
  const SettingsDynamic = useSelector((state) => state.settings);

  // window size
  const size = useWindowSize();

  // React springs
  const navSpring = useSpring({
      height: showNav ? (size.height - 0) + 'px' : '41px',
  });

  const navContentSpring = useSpring({
      delay: showNav ? 200 : 0,
      display: showNav ? "flex" : "none",
      height: showNav ? '100%' : '0%',
      opacity: showNav ? '1' : '0',
  });

  const hamburgerSpringSVG = useSpring({
      transform: showNav ? 'translateX(1px) translateY(-1px)' : 'translateX(0px) translateY(0px)',
  });

  const hamburgerSpringTop = useSpring({
      transform: showNav ? 'rotate(45deg)' : 'rotate(0deg)',
  });

  const hamburgerSpringMiddle = useSpring({
      opacity: showNav ? '0' : '1',
  });

  const hamburgerSpringBottom = useSpring({
      transform: showNav ? 'rotate(-45deg)' : 'rotate(0deg)',
  });

  // #TODO - add useTrail react spring for menu links

  const toggleNav = () => {
    setShowNav(!showNav)
  }

  const hideNav = () => {
    setShowNav(false)
  }

  const getFacebookLink = () => {
    if (i18n.language === "en-us"){
      return "https://www.facebook.com/mpbcomUS/"
    }
    if (i18n.language === "en-uk"){
      return "https://www.facebook.com/mpbcom"
    }
    if (i18n.language === "de-de"){
      return "https://www.facebook.com/mpbcomDE"
    }
    if (i18n.language === "fr-fr"){
      return "https://https://www.facebook.com/mpbcomFR"
    }
    if (i18n.language === "en-eu"){
      return "https://www.facebook.com/mpbcom"
    }
    return "https://www.facebook.com/mpbcomUS/"
  }

return (
  <animated.div
    config={{ duration: 500 }}
    id="header"
    className={showNav ? 'headerOpen' : 'headerClosed'}
    background="blueDark"
    align="start"
    style={{
      flexGrow: 0,
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      ...navSpring
    }}
  >

  <Box
    id="mainNavTop"
    direction="row"
    align="center"
    justify="between"
  >
      <Box id="logoContainer" direction="row" align="center" gap="small">
        <Link to={`${match.url}`} onClick={hideNav}>
          <img
            id="mpb_logo"
            src={logo}
            alt="MPB"
          />
        </Link>
        {/**<Heading level='3' margin='none'>MPB</Heading>**/}
      </Box>

      <Nav direction="row">
         <div id="hamburger-wrapper">
           <animated.svg 
              style={{transformOrigin: "50% 50%", ...hamburgerSpringSVG}} 
              onClick={() => { setShowNav(!showNav) }} 
              id="hamburger" 
              viewBox="0 0 100 80"
            >
             <animated.rect 
                style={{transformOrigin: "0% 25%", ...hamburgerSpringTop}} 
                className="hamburger-line" 
                width="100" 
                height="10"
             ></animated.rect>
             <animated.rect 
                style={hamburgerSpringMiddle} 
                className="hamburger-line" 
                y="30" 
                width="100" 
                height="10"
             ></animated.rect>
             <animated.rect 
                style={{transformOrigin: "25% 75%", ...hamburgerSpringBottom}} 
                className="hamburger-line" 
                y="60" 
                width="100" 
                height="10"
              ></animated.rect>
           </animated.svg>
         </div>
      </Nav>
    </Box>
    <animated.div
      id="mainNavBottom"
      style={{
        display: "flex",
        alignContent: "stretch",
        flexDirection: "column",
        ...navContentSpring
      }}
    >
      <div
       id="navContent"
     >
       <div className="navContentCol">
         <img
           src={hof_logo}
           srcSet={`${hof_logo} 1x, ${hof_logo_2x} 2x, `}
           id="hof_logo"
           alt="The Photo and Video Kit Hall of Fame - Brought to you by MPB"
           style={{
           }}
         />
        </div>
        <div className="navContentCol" id="navLinks">
          <div id="navLinksContainer">
            <Link to={`${match.url}`} onClick={toggleNav}>
              <Trans>Home</Trans>
            </Link>
            <Link to={`${match.url}/museum`} onClick={toggleNav}>
              <Trans>Museum</Trans>
            </Link>
            {
              Settings.GetDynamicBool(SettingsDynamic, 'show_categories', Settings.SHOW_CATEGORIES) ?
                <Link
                  to={`${match.url}#nominees`}
                  onClick={() => {
                    toggleNav();
                    scrollToID("nominees")
                  }}
                >
                  <Trans>Nominees</Trans>
                </Link>
              :
              null
          }
          { /*
            <Link to={`${match.url}/class-of-2022`} onClick={toggleNav} className="smaller">
              <Trans>Class of 2022</Trans>
            </Link>
            <Link to={`${match.url}/class-of-2021`} onClick={toggleNav} className="smaller">
              <Trans>Class of 2021</Trans>
            </Link>
            <Link to={`${match.url}/class-of-2020`} onClick={toggleNav} className="smaller">
              <Trans>Class of 2020</Trans>
            </Link>
          */}
            <Link to={`${match.url}/nominating-process`} onClick={toggleNav}>
              <Trans>Nominating Process</Trans>
            </Link>
            {/*
            <Link to={`${match.url}/press-and-media`} onClick={toggleNav}>
              <Trans>Contact</Trans>
            </Link>
            */}
            <Link to={`${match.url}/about-mpb`} onClick={toggleNav}>
              <Trans>About MPB</Trans>
            </Link>
          </div>
        </div>
      </div>
      <div
       id="navContentFooter"
     >
      <div id="navContentFooterCopyright">
        &copy; MPB {currentYear}
      </div>
      <div id="navContentFooterLinks">
        <LanguageSelector
          i18n={i18n}
          match={match}
          location={location}
        />
        {/**
        <Link to={`${match.url}/about-mpb`} onClick={toggleNav}>
          <Trans>About MPB</Trans>
        </Link>
        **/}
        <Link to={`${match.url}/privacy-policy`} onClick={toggleNav}>
          <Trans>Privacy Policy</Trans>
        </Link>
        {SettingsDynamic?.show_sweepstakes_terms &&
          SettingsDynamic.show_sweepstakes_terms.toLowerCase() ==
            "true" && (
            <Link to={`${match.url}/terms-and-conditions`} onClick={toggleNav}>
              <Trans>Terms & Conditions</Trans>
            </Link>
        )}
      </div>
      <div id="navContentFooterSocial">
        <a target="_blank" href="https://www.instagram.com/mpbcom/"><FontAwesomeIcon icon={faInstagram} /></a>
        <a target="_blank" href={getFacebookLink()}><FontAwesomeIcon icon={faFacebook} /></a>
        <a target="_blank" href="https://www.youtube.com/c/mpbcom"><FontAwesomeIcon icon={faYoutube} /></a>
        <a target="_blank" href="https://www.tiktok.com/@mpbcom/"><FontAwesomeIcon icon={faTiktok} /></a>
      </div>
     </div>
    </animated.div>
  </animated.div>
)
}

export default MyNav;
